import Page from './Page';
import { AddCommissionPage } from './AddCommissionPage';
import reducer from './reducer';

export const reducers = { commissionManager: reducer };

export { Page, AddCommissionPage };
export default { Page, AddCommissionPage, reducers };